import {
  NewOrderImpressionsMode,
  NewOrderType,
  OrderInfosKeys,
  TNewOrderCountry,
} from "@/entities/new-order";
import {
  TBaseKeyValue,
  TViewsKeyValue,
} from "@/entities/new-order/types/new-order-keywords.type";
import { calcImpressions } from "@/features/new-order/country-item/lib";
import { ICampaignInfo } from "@/Models/ApiModels";
import { TImpressionsInfo } from "@/Pages/CreateCampaignPage/Models/CountryModel";
import { getCountriesOfKeywords } from "./get-countries-of-keywords";
import { getKeywordsUniqueKeys } from "./get-keywords-unique-keys";

export function getParsedExtendCountries(
  order: ICampaignInfo,
  newDateArray: string[],
  oldDateArray: string[],
) {
  // Получаем список уникальных стран из ключевых слов
  const countriesList = getCountriesOfKeywords(order.keywords);

  // Получаем информацию о показах по странам
  const impressionsInfo = order.infos.find(
    (info) => info.info_key === OrderInfosKeys.impressions_additional_info,
  )?.info_data as TImpressionsInfo | undefined;

  // Собираем итоговый массив по странам
  return countriesList.map((country) => {
    const countryImpressionsType = impressionsInfo?.[country]?.type;
    const impressionsKeysValues = impressionsInfo?.[country]?.keys || {};

    // Получаем все ключевые слова для данной страны
    const countryKeywords = order.keywords.filter(
      (keyword) => keyword.country === country,
    );

    // Создаём объект страны с нужными полями
    const newCountry: TNewOrderCountry = {
      geo: country,
      keywords: {},
      ...(countryImpressionsType
        ? { impressions: { type: countryImpressionsType } }
        : {}),
    };

    // Создаём структуру keywords для каждой новой даты
    for (let i = 0; i < newDateArray.length; i++) {
      const newDate = newDateArray[i];
      const oldDate = oldDateArray[i];

      // Инициализируем объект для даты в зависимости от типа заказа
      newCountry.keywords[newDate] =
        order.type === NewOrderType.install_with_views
          ? ({} as TViewsKeyValue)
          : order.type === NewOrderType.review
            ? []
            : ({} as TBaseKeyValue);

      // Заполняем ключевые слова для текущей даты
      for (const key of getKeywordsUniqueKeys(countryKeywords)) {
        if (order.type === "review-manual") {
          return newCountry; // Для отзывов не обрабатываем ключевые слова
        }
        // Находим значение для ключевого слова в старой дате
        const keywordValue =
          countryKeywords
            .filter((keyword) => keyword.date === oldDate)
            .find((item) => item.keyword === key)?.value || 0;

        if (order.type === NewOrderType.install_with_views) {
          const keywords = newCountry.keywords[newDate] as TViewsKeyValue;

          // Создаем структуру с installs, views и CR
          keywords[key] = {
            installs: keywordValue,
            views: 0,
            CR: 100,
          };

          // Копируем информацию о показах
          if (
            countryImpressionsType === NewOrderImpressionsMode.CR &&
            impressionsKeysValues[key] !== undefined
          ) {
            keywords[key].CR = impressionsKeysValues[key];
            keywords[key].views = keywordValue
              ? calcImpressions(keywordValue, impressionsKeysValues[key])
              : 0;
          } else if (
            countryImpressionsType === NewOrderImpressionsMode.Impressions &&
            impressionsKeysValues[key] !== undefined
          ) {
            keywords[key].views = impressionsKeysValues[key];
          }
        } else {
          // Для обычного типа просто копируем значение
          const keywords = newCountry.keywords[newDate] as TBaseKeyValue;
          keywords[key] = keywordValue;
        }
      }
    }

    return newCountry;
  });
}
